import { render } from "./AddPlacementWizard.vue?vue&type=template&id=2b9c87be&scoped=true"
import script from "./AddPlacementWizard.vue?vue&type=script&lang=js"
export * from "./AddPlacementWizard.vue?vue&type=script&lang=js"

import "./AddPlacementWizard.vue?vue&type=style&index=0&id=2b9c87be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9c87be"]])

export default __exports__